<template>
	<!-- 更新旧文 -->
	<div class="unpdataOldTextBox">
		<!-- 头部 -->
		<van-sticky>
			<div class="headerBox">
				<div class="headerQuery">
					<!-- @click="back" -->
					<div class="arrImg" @click="back">
						<img src="../../assets/img/leftarr_tit.png" alt="">
					</div>
					<p class="header_titile">更新旧文</p>
					<div @click="jumpQingjia" class="header_right" v-if="userState == 3">请假</div>
				</div>
			</div>
		</van-sticky>
		<!-- 筛选导航 -->
		<!-- 筛选框 -->
		<div class="selectBoxtab">
			<div>
				<div class="rightSelect" @click="firstSelectBox">
					<p v-model="firstselectValue">{{firstselectValue}}</p>
					<img src="../../assets/img/downarr.png" alt="" />
				</div>
				<ul class="selectItem" v-show="firstSelect">
					<li v-for="(selectItem,index) in firstSelectLists" :key="index" @click="firstselectItemFn(selectItem,index)"
					 :class="firstselectIndex == index ? 'active_color' : '' ">
						<img src="../../assets/img/all_active.png" alt="" v-show="firstselectIndex == 0 && index == 0 ? true : false" />
						<img src="../../assets/img/all.png" alt="" v-show="firstselectIndex != 0 && index == 0 ? true : false" />
						<img src="../../assets/img/yunicon.png" alt="" v-show="index == 1 && firstselectIndex != 1  ? true : false">
						<img src="../../assets/img/yunicon.png" alt="" v-show="index == 2 && firstselectIndex != 2  ? true : false">
						<img src="../../assets/img/yunicon.png" alt="" v-show="index == 3 && firstselectIndex != 3  ? true : false">
						<img src="../../assets/img/yunicon_active.png" alt="" v-show="index == firstselectIndex && firstselectIndex != 0  ? true : false">
						<span>{{selectItem}}</span>
						<img class="queryIcon" src="../../assets/img/query.png" alt="" v-show="firstselectIndex == index ? true : false">
					</li>
				</ul>
			</div>
			<div>
				<div class="rightSelect" @click="secondSelectBox">
					<p v-model="secondselectValue">{{secondselectValue}}</p>
					<img src="../../assets/img/downarr.png" alt="" />
				</div>
				<ul class="selectItem secondSelectItem" v-show="secondSelect">
					<li v-for="(selectItem,index) in secondSelectLists" :key="index" @click="secondselectItemFn(selectItem,index)"
					 :class="secondselectIndex == index ? 'active_color' : '' ">
						<img src="../../assets/img/bookicon_active.png" alt="" v-show="index == 0 && secondselectIndex == 0  ? true : false" />
						<img src="../../assets/img/bookicon.png" alt="" v-show="index == 0 && secondselectIndex != 0  ? true : false" />
						<img src="../../assets/img/listicon.png" alt="" v-show="secondselectIndex != 1 && index == 1 ? true : false" />
						<img src="../../assets/img/listIcon_active.png" alt="" v-show="secondselectIndex == 1 && index == 1 ? true : false" />
						<span>{{selectItem}}</span>
						<img class="queryIcon" src="../../assets/img/query.png" alt="" v-show="secondselectIndex == index ? true : false">
					</li>
				</ul>
			</div>
		</div>
		<!-- 封面模式 -->
		<!-- 跳转到更新旧文详情页面  /updataoldtextinfo-->
	<!-- 	<div class="listBox" v-for="(item,index) in getUpdateBooks" :key="index" v-if="secondselectIndex == 0 && firstselectValue == item.series_name ? true :false">
			<div class="checkedBooklist">
				<div class="biaoqianTitle">
					<h4>{{item.series_name}}</h4>
					<img src="../../assets/img/rightarr_pink.png" alt="">
				</div>
				<div class="checkedBook" v-for="(itm,ind) in item.book_list" @click="jumpUpdataInfo(itm.id)">
					<div class="bookNameImg">
						<img :src="$api.$BASE_URL_img+itm.cover_image" alt="">
					</div>
					<span>{{itm.name}}</span>
				</div>
			</div>
		</div> -->
		<!-- 完结金榜 -->
		<div class="soltPhItemBox" v-for="(item,index) in getUpdateBooks" :key="index" v-if="secondselectIndex == 0 && firstselectValue == item.series_name ? true :false">
			<div class="yunjin_jbBox">
				<div class="limiteFooter">
					<p class="btnLimite">{{item.series_name}}</p>
						<div class="limiteAprr">
							<img src="../../assets/img/rightarr_pink.png" alt="">
						</div>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(itm,ind) in item.book_list">
							<div @click="jumpUpdataInfo(itm.id)" style="position: relative">
								<div class="bookImg">
									<img :src="$api.$BASE_URL_img + itm.cover_image" alt="">
									<!-- 存稿 -->
									<span v-if="itm.status == 2 ? true : false" class="bookState active_cg"></span>
									<!-- 曝光文案 -->
									<span v-if="itm.status == 3 ? true : false" class="bookState active_bg"></span>
									<!-- 请假 -->
									<span v-if="itm.is_leave == 1 ? true : false" class="bookState active_qj"></span>
								</div>

								<p class="bookName"><span v-for="(books_name,bookNameIndex) in itm.name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<div class="soltPhItemBox" v-for="(item,index) in getUpdateBooks" :key="index" v-if="secondselectIndex == 0 && firstselectValue == '全部' ? true :false">
			<div class="yunjin_jbBox">
				<div class="limiteFooter">
					<p class="btnLimite">{{item.series_name}}</p>
				</div>
				<div class="yunjin_jb">
					<swiper class="swiper" :options="jb_swiperOption">
						<swiper-slide v-for="(itm,ind) in item.book_list">
							<div @click="jumpUpdataInfo(itm.id)" style="position: relative">
								<div class="bookImg">
									<img :src="$api.$BASE_URL_img + itm.cover_image" alt="">
									<!-- 存稿 -->
									<span v-if="itm.status == 2 ? true : false" class="bookState active_cg"></span>
									<!-- 曝光文案 -->
									<span v-if="itm.status == 3 ? true : false" class="bookState active_bg"></span>
									<!-- 请假 -->
									<span v-if="itm.is_leave == 1 ? true : false" class="bookState active_qj"></span>
								</div>
								<p class="bookName"><span v-for="(books_name,bookNameIndex) in itm.name" v-if="bookNameIndex > 5 ? false : true">{{books_name}}</span></p>
							</div>
						</swiper-slide>
					</swiper>
				</div>
			</div>
		</div>
		<!-- ---------------------------------------------列表分化----------------------------------------------------- -->
		<!-- 列表模式 -->
		<div class="blockBox"  v-for="(itm,index) in getUpdateBooks" :key="index" v-if="secondselectIndex == 1 && firstselectValue == itm.series_name? true :false">
			<div class="biaoqianTitle">
				<h4>{{itm.series_name}}</h4>
				<!-- <img src="../../assets/img/rightarr_pink.png" alt=""> -->
			</div>
			<!-- @click="jumpBookinfo(item.book_id)" -->
			<div class="blockLeft" v-for="(item,index) in itm.book_list" :key="index" @click="jumpUpdataInfo(item.id)">
				<div class="book_Img">
					<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" />
				</div>
				<div class="blockBookInfo">
					<div class="bookName"><span>{{item.name}}</span>
						<p><span>{{item.total_words}}字</span><span class="wanjie">{{item.progress_status}}</span></p>
					</div>
					<div class="auther"><span>{{item.author}}</span></div>
					<p class="bookType">{{item.original_name + '-' + item.appetency_name + '-' + item.epoch_name + '-' + item.type_name}}</p>
					<div class="introduction">
						<p>简介：{{item.introduce}}</p>
					</div>
					<div class="book_button">
						<button v-for="itemName in item.lable">{{itemName.name}}</button>
					</div>
				</div>
			</div>
		</div>
		<!-- 列表模式 -->
		<div class="blockBox"  v-for="(itm,index) in getUpdateBooks" :key="index" v-if="secondselectIndex == 1 && firstselectValue == '全部'? true :false">
			<div class="biaoqianTitle">
				<h4>{{itm.series_name}}</h4>
				<!-- <img src="../../assets/img/rightarr_pink.png" alt=""> -->
			</div>
			<!-- @click="jumpBookinfo(item.book_id)" -->
			<div class="blockLeft" v-for="(item,index) in itm.book_list" :key="index" @click="jumpUpdataInfo(item.id)">
				<div class="book_Img">
					<img :src="$api.$BASE_URL_img+item.cover_image" alt="图书" />
				</div>
				<div class="blockBookInfo">
					<div class="bookName"><span>{{item.name}}</span>
						<p><span>{{item.total_words}}字</span><span class="wanjie">{{item.progress_status}}</span></p>
					</div>
					<div class="auther"><span>{{item.author}}</span></div>
					<p class="bookType">{{item.original_name + '-' + item.appetency_name + '-' + item.epoch_name + '-' + item.type_name}}</p>
					<div class="introduction">
						<p>简介：{{item.introduce}}</p>
					</div>
					<div class="book_button">
						<button v-for="itemName in item.lable">{{itemName.name}}</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				firstselectValue: '全部', //筛选框默认选中
				secondselectValue: '封面模式', //筛选框默认选中
				firstselectIndex: 0, //选中索引
				secondselectIndex: 0,
				firstSelect: false, //控制显示隐藏
				secondSelect: false, //控制显示隐藏
				firstSelectLists: ["全部"],
				secondSelectLists: ["封面模式","列表模式"],
				getUpdateBooks: [],
				jb_swiperOption: {
					slidesPerView: 3.5,
					paginationClickable: false,
					spaceBetween: 35,
					freeMode: false
				},
				userState:'',//用户类别
			}
		},
		created() {
			this.secondselectIndex = localStorage.getItem('secondselectIndex') || 0;
			if(this.secondselectIndex  == 0){
				this.secondselectValue = '封面模式'
			}else{
				this.secondselectValue = '列表模式'
			}
			this.get_update_books();
			this.userState = JSON.parse(localStorage.getItem('userInfoData')).state;
		},
		methods: {
			firstSelectBox() { //下拉框选项 显示 -- 1
				this.firstSelect = !this.firstSelect
			},
			secondSelectBox() { //下拉框选项 显示 -- 2
				this.secondSelect = !this.secondSelect
			},
			firstselectItemFn(value, index) { //下拉框选择 -- 1
				this.firstselectValue = value;
				this.firstselectIndex = index;
				this.firstSelect = !this.firstSelect;
			},
			secondselectItemFn(value, index) { //下拉框选择 -- 2
			console.log(index,'index')
				this.secondselectValue = value;
				this.secondselectIndex = index;
				this.secondSelect = !this.secondSelect;
				localStorage.setItem('secondselectIndex',this.secondselectIndex)
			},
			//跳转请假界面
			jumpQingjia() {
				this.$router.push('/qingjia')
			},
			back() {
				this.$router.push('/userinfo')
			},
			// <!-- 跳转到更新旧文详情页面  /updataoldtextinfo-->
			jumpUpdataInfo(data) {
				this.$router.push({
					path: '/updataoldtextinfo',
					query: {
						id: data
					}
				})
			},
			get_update_books() {
				this.$axios.post(this.$api.get_update_books).then(res => {
					this.getUpdateBooks = res.data.data;
					// 
					Object.getOwnPropertyNames(this.getUpdateBooks).forEach(key => {
						if(this.getUpdateBooks[key].series_name != undefined){
							this.firstSelectLists.push(this.getUpdateBooks[key].series_name)
						}
					})
				})
			}
		}
	}
</script>

<style lang="less" scoped>
	.unpdataOldTextBox {
		color: #000;
		// 头部
		.headerBox {
			height: 160px;
			background-color: #ff4081;
			display: flex;
			background: url(../../assets/img/myicon/indexBgc.png) no-repeat 0% 88% #fff;
			background-size: 100%;
			border-bottom: 1px solid #f0f0f0;/*no*/
			.headerQuery {
				margin-top: 80px;
				padding: 0 16px;
				position: relative;
				display: flex;
				width: 100%;
				height: 80px;
				line-height: 80px;
				color: #000;

				.arrImg {
					img {
						width: 40px;
						position: absolute;
						top: 50%;
						transform: translateY(-50%);
						left: 0px;
					}
				}

				.header_titile {
					flex: 1;
					text-align: center;
					font-size: 34px;
					/*px*/
				}
				.header_right {
					position: absolute;
					right: 16px;
					top: 50%;
					transform: translateY(-50%);
					font-size: 30px;
					/*px*/
				}
			}

		}

		//筛选导航
		.selectBoxtab {
			background-color: #fff;
			height: 100px;
			margin-bottom: 10px;
			position: relative;

			div {
				// width: 200px;
				float: left;
				position: relative;
				padding: 20px 16px;
				margin-right: 10px;

				.rightSelect {
					background-color: #fff;
					border: 0;
					padding: 10px 20px;
					font-size: left;
					border-radius: 5px;
					// border: 1px solid #ff4081;/*no*/
					position: relative;

					p {
						display: inline-block;
						color: #000;
						padding-right: 20px;
						font-size: 28px;/*px*/
					}

					img {
						margin-left: 10px;
						vertical-align: middle;
						width: 20px;
						position: absolute;
						top: 50%;
						right: 10px;
						transform: translateY(-50%);
					}
				}

				.selectItem {
					position: absolute;
					top: 80px;
					left: 20px;
					background-color: #fff;
					line-height: 60px;
					z-index: 1000;
					width: 200px;
					border-radius: 5px;
					-webkit-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
					/*no*/
					-moz-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
					/*no*/
					box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.1);
					/*no*/
					padding: 0px 20px;

					li {

						border-bottom: 1px solid #f0f0f0;
						/*no*/
						position: relative;

						.queryIcon {
							position: absolute;
							right: 0;
							top: 50%;
							transform: translateY(-50%);
							width: 20px;

						}

						img {
							width: 20px;
							padding-right: 20px;
						}

						.queryIcon {
							position: absolute;
							top: 50%;
							right: 16px;
							transform: translateY(-50%);
						}
					}

					.active_color {
						color: #ff4081;
						border-bottom: 4px solid #f0f0f0;
						/*no*/
					}
				}

				.selectItem.secondSelectItem {
					left: 40px;
				}
			}
		}

		//封面模式
		.listBox {
			margin-bottom: 10px;

			// 系列
			.biaoqianTitle {
				position: relative;
				background-color: #fff;
				padding: 0 16px;

				h4 {
					color: #ff4081;
					padding: 20px 0;
					line-height: 40px;
					font-size: 30px;
					/*px*/
				}

				img {
					position: absolute;
					top: 50%;
					right: 10px;
					transform: translateY(-50%);
					width: 50px;
				}
			}

			//列表
			.checkedBooklist {
				overflow: hidden;
				padding: 0 16px;
				background-color: #fff;

				.checkedBook {
					float: left;
					width: calc((100vw - 107px) / 4);
					margin-right: 25px;
					margin-bottom: 10px;
					color: #3d3d3d;
					float: left;

					.bookNameImg {
						position: relative;

						img {
							width: 172px;
							height: 280px;
							vertical-align: middle;
							-webkit-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
							/*no*/
							-moz-box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
							/*no*/
							box-shadow: 0 0 9px 0px rgba(0, 0, 0, 0.2);
							/*no*/
						}
					}

					span {
						padding-top: 5px;
						font-size: 22px;
						/*px*/
						white-space: nowrap;
					}

				}

				.checkedBook:nth-child(4n) {
					padding-right: 0;
				}
			}

		}
		.soltPhItemBox {
			padding: 0 16px;
			background-color: #fff;
		}
		
		.soltPhItemBox:last-child {
			border-bottom: 0;
		}
		
		.soltBox {
			padding-top: 60px;
			background-color: #fff;
		}
		
		// 云锦金榜
		.yunjin_jbBox {
			// height: 320px;
			border-bottom: 1px solid #f0f0f0;
			/*no*/
			padding: 20px 0px;
			padding-top: 0;
		
			.limiteFooter {
				display: flex;
				justify-content: space-between;
				background-color: #fff;
				line-height: 80px;
				position: relative;
		
				.btnLimite {
					font-size: 30px;
					/*px*/
					color: #ff4081;
					font-weight: 700;
					// transform: scale(1.1);
				}
		
				.limiteArr {
					img {
						width: 50px;
						position: absolute;
						top: 50%;
						right: 0;
						transform: translateY(-50%);
					}
				}
			}
		
			.yunjin_jb {
				margin-top: 10px;
				// height: 360px !important;
			
				.swiper-container {
					height: 100%;
			
					.swiper-slide {
						width: 24% !important;
						margin-right: 8px !important;
							div{
								text-align: center;
								img {
									width: 155px;
									height: 220px;
									vertical-align: middle;
									-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
									/*no*/
									-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
									/*no*/
									box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
									/*no*/
								}
							}
			
						.bookImg {
							position: relative;
			
							.bookState {
								position: absolute;
								top: 10px;
								right: 6%;
								// border-top-left-radius: 30px;
								// border-bottom-left-radius: 30px;
								padding-left: 15px;
								padding-right: 10px;
								font-size: 22px;
								/*px*/
								color: #fff;
							}
						}
						.bookImg {
							position: relative;
						
							.bookState {
								position: absolute;
								top: 10px;
								right: 6%;
								// border-top-left-radius: 30px;
								// border-bottom-left-radius: 30px;
								padding-left: 15px;
								padding-right: 10px;
								font-size: 22px;
								/*px*/
								width: 50px;
								height: 80px;
							}
						
							// 存稿
							.active_cg {
								background: url(../../assets/img/cungao_icon.png) no-repeat;
								background-size: 100% 80%;
							}
						
							//请假
							.active_qj {
								background: url(../../assets/img/qingjia_icon.png) no-repeat;
								background-size: 100% 80%;
							}
						
							//销假
							.active_xj {
								background: url(../../assets/img/xiaojia_icon.png) no-repeat;
								background-size: 100% 80%;
							}
							//曝光文案
							.active_bg {
								background: url(../../assets/img/baoguang_icon.png) no-repeat;
								background-size: 100% 80%;
							}
						}
						.bookName {
							font-size: 22px;
							/*px*/
							overflow: hidden;
							white-space: nowrap;
							// text-overflow: ellipsis;
							padding-top: 10px;
							color: #3d3d3d;
							text-align: center;
						}
			
						.jianjie {
							font-size: 22px;
							/*px*/
							color: #a3a3a3;
							padding-top: 5px;
						}
					}
				}
			}
		}
		//列表模式
		.blockBox {
			overflow: hidden;
			// position: relative;
			background-color: #fff;
			padding: 0px 16px;
			// 系列
			.biaoqianTitle {
				position: relative;
				background-color: #fff;
				padding: 0 16px;
			
				h4 {
					color: #ff4081;
					padding: 20px 0;
					line-height: 40px;
					font-size: 30px;
					/*px*/
				}
			
				img {
					position: absolute;
					top: 50%;
					right: 10px;
					transform: translateY(-50%);
					width: 50px;
				}
			}
			.blockLeft {
				display: flex;
				background-color: #fff;
				padding: 20px 0px;
				padding-bottom: 20px;
				border-bottom: 1px solid #f0f0f0;

				/*no*/
				.book_Img {
					// width: 138px;
					height: 270px;

					img {
						display: block;
						float: left;
						width: 185px;
						height: 260px;
						vertical-align: middle;
						-webkit-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						-moz-box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
						box-shadow: 0 3px 3px 0px rgba(0, 0, 0, 0.3);
						/*no*/
					}
				}

				.blockBookInfo {
					margin-left: 10px;
					flex: 1;
					font-size: 26px;
					/*px*/
					line-height: 30px;

					.auther {
						color: #000;
						font-size: 26px;
						/*px*/
						opacity: 0.6;
					}
					.bookImg {
						position: relative;
					
						.bookState {
							position: absolute;
							top: 10px;
							right: 6%;
							// border-top-left-radius: 30px;
							// border-bottom-left-radius: 30px;
							padding-left: 15px;
							padding-right: 10px;
							font-size: 22px;
							/*px*/
							// color: #fff;
							width: 50px;
							height: 80px;
						}
					
						// 存稿
						.active_cg {
							background: url(../../assets/img/cungao_icon.png) no-repeat;
							background-size: 100% 80%;
						}
												
						//请假
						.active_qj {
							background: url(../../assets/img/qingjia_icon.png) no-repeat;
							background-size: 100% 80%;
						}
												
						//销假
						.active_xj {
							background: url(../../assets/img/xiaojia_icon.png) no-repeat;
							background-size: 100% 80%;
						}
						//曝光文案
						.active_bg {
							background: url(../../assets/img/baoguang_icon.png) no-repeat;
							background-size: 100% 80%;
						}
					}
					.bookName {
						// line-height: 40px;
						padding-bottom: 20px;
						font-size: 30px;
						/*px*/
						// font-weight: 600;
						color: #000000;
						display: flex;
						justify-content: space-between;

						>span {
							display: block;
							width: 30vw;
							height: 32px;
							line-height: 32px;
							overflow: hidden;
							-webkit-line-clamp: 1;
							line-clamp: 1;
						}

						p {
							display: inline-block;
							font-weight: 400;

							span {
								margin-left: 8px;
								color: #4c4c4c;
								font-size: 26px;
								/*px*/
							}
						}
					}

					.bookType,
					.introduction {
						padding-top: 20px;
						color: #000;
						font-size: 24px;/*px*/
						opacity: 0.4;
					}

					.introduction {
						width: 60vw;
						padding-top: 15px;

						p {
							overflow: hidden;
							white-space: nowrap;
							text-overflow: ellipsis;
						}
					}

					.book_button {
						margin-top: 15px;
						display: flex;
						align-items: center;
					
						button {
							border: 0;
							outline: none;
							border: 1px solid #fec6d5;
							/*no*/
							border-radius: 28px;
							padding: 0px 20px;
							display: inline-block;
							line-height: 36px;
							/*px*/
							background-color: #fff8fa;
							color: #fa7298;
							margin-right: 20px;
							font-size: 24px;
							/*px*/
							overflow: hidden;
							text-overflow: ellipsis;
							white-space: nowrap;
						}
					
						.active {
							background-color: #fa7298;
							color: #ffffff;
						}
					}
				}
			}

		}
	}
</style>
